import { oids } from "@/configs/Settings";
import type { TeleconsultoriaGuest } from "../../types";

/** `Practitioner/<oid>-<cpf>` → `<cpf>`. Vazio quando a reference não segue o padrão. */
export function cpfFromPractitionerReference(practitionerReference: string): string {
  const marker = `Practitioner/${oids.cpf}-`;
  if (!practitionerReference.startsWith(marker)) return "";
  return practitionerReference.slice(marker.length);
}

/** CNPJ puro a partir do id da organização (aceita `<oid>-<cnpj>` ou só o CNPJ). */
function cnpjFromOrganizationId(organizationId: string): string {
  return organizationId.replace(`${oids.cnpj}-`, "");
}

/**
 * PractitionerRole no formato do sistema: `PractitionerRole/<cnpj>-<oid.cpf>-<cpf>`.
 * É o mesmo id observado pelo SSE de tasks (`TaskWatchingContext`).
 */
export function practitionerRoleReference(params: {
  organizationId: string;
  practitionerReference: string;
}): string {
  const cnpj = cnpjFromOrganizationId(params.organizationId);
  const cpf = cpfFromPractitionerReference(params.practitionerReference);
  if (!cnpj || !cpf) return "";
  return `PractitionerRole/${cnpj}-${oids.cpf}-${cpf}`;
}

/** PractitionerRole do convidado na organização do HCS dele. Vazio se não der para montar. */
export function guestPractitionerRoleReference(guest: TeleconsultoriaGuest): string {
  if (!guest.organizationId) return "";
  return practitionerRoleReference({
    organizationId: guest.organizationId,
    practitionerReference: guest.practitioner.reference,
  });
}
